 // core version + navigation, pagination modules:
//  import Swiper, { Navigation, Pagination } from 'swiper';
  // import Swiper styles
//   import 'swiper/css';
// import 'swiper/css/navigation';

import { swiperOptions } from "./swiper-options";


//Only enable swiper when more than one slide available
(function($) { "use strict";

	var swiperContainer = $('.swiper-container');
		
	// check page contains element
	if( swiperContainer.length ) {

		swiperContainer.each(function () {

      var numberOfSlides = $(this).find('.swiper-slide').length;

      if (numberOfSlides > 1) {
        var swiper = new Swiper($(this), swiperOptions);
      }

		});

	}


})(jQuery);












// DEBUG

// document.querySelector('[data-toggle]').addEventListener('click', function(){
//   if (swiper.realIndex == 0) {
//     swiper.slideTo(swiper.slides.length - 1);
//   } else {
//     swiper.slideTo(0);
//   }
// });

// function logIndex () {
//   requestAnimationFrame(logIndex);
//   console.log(swiper.realIndex);
// }
// logIndex();